{
  "version": 1,
  "asset_id": "a748a63c-cf9c-479a-9c80-27987f4d15b8",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a748a63c-cf9c-479a-9c80-27987f4d15b8/bypass-revision-completed-pouch-en.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a748a63c-cf9c-479a-9c80-27987f4d15b8/bypass-revision-completed-pouch-en.webp",
  "original_filename": "bypass-revision-completed-pouch-en.webp",
  "size": 154382,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:12:43Z"
}
